export const recurrences = {
    lastThirtyDays: 'last-thirty-days',
    yearToDate: 'year-to-date',
    lastTwelveMonths: 'last-twelve-months'
};

export const periods = {
    current: 'current_prior',
    yearToDate: 'ytd_pytd',
    lastTwelveMonths: 'ltm_ptm'
};
